
export default class ScrollTo {
    constructor() {
        console.log('%c👍🏼 Scroll To', 'color: yellow');
        
        this.scrollTo = [...document.querySelectorAll('.scroll-to')];
        this.mainNav = document.querySelector('.navbar');
 
    }
    init() {
        let self = this;
        this.scrollTo.forEach(elem => elem.addEventListener('click', e => {
            e.preventDefault();
		    self.scrollToEl(e.target.getAttribute('href'))
        }))
    }
    scrollToEl(selector) {
        console.log(selector);
        const target = document.querySelector(selector);
    console.log(target);
        if (!target) {
            return;
        }
    
        const top = target.offsetTop - window.scrollY - this.mainNav.offsetHeight ;
    
        window.scrollBy({
            behavior: 'smooth',
            top,
            left: 0
        });
    }
}







// export function init() {


// 	els = [...document.querySelectorAll('.scroll-to')];
//     console.log('els', els);

// 	mainNav = document.querySelector('.navbar');
// 	// progressNav = document.querySelector('.dr_progress-navigation');

// 	// checkQueryParams();

// 	events();
// }

// function events() {
// 	els.forEach(el => el.addEventListener('click', e => {
// 		e.preventDefault();
// 		scrollToEl(e.target.getAttribute('href'))
// 	}));
// }

// // function checkQueryParams() {
// // 	const urlParams = new URLSearchParams(location.search);

// // 	urlParams.has('b') && scrollToEl('#' + urlParams.get('b'));
// // }

// function scrollToEl(selector) {
// 	const target = document.querySelector(selector);

// 	if (!target) {
// 		return;
// 	}

// 	const top = target.offsetTop - window.scrollY - mainNav.offsetHeight - (progressNav ? progressNav.offsetHeight : 0);

// 	window.scrollBy({
// 		behavior: 'smooth',
// 		top,
// 		left: 0
// 	});
// }